import { readable } from "svelte/store";

// The resolved app theme ("light" | "dark"), read from `data-theme` on <html>,
// which ThemeToggle flips. For third-party widgets that take a theme name
// instead of following the CSS tokens.
const current = () =>
  document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";

export const appTheme = readable(current(), (set) => {
  const observer = new MutationObserver(() => set(current()));
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
  return () => observer.disconnect();
});
